const upperCase = new RegExp('[A-Z]');
const lowerCase = new RegExp('[a-z]');
const numbersMatch = new RegExp('[0-9]');
const specialchars = new RegExp('[^a-zA-Z0-9]');

export function checkStrength(password: string) {
  let characters = 0;
  let capitalletters = 0;
  let lowerletters = 0;
  let numbers = 0;
  let special = 0;

  if (!password) {
    return -1;
  }

  if (password.length > 8) {
    characters = 1;
  } else {
    characters = 0;
  }

  if (password.match(upperCase)) {
    capitalletters = 1;
  } else {
    capitalletters = 0;
  }

  if (password.match(lowerCase)) {
    lowerletters = 1;
  } else {
    lowerletters = 0;
  }

  if (password.match(numbersMatch)) {
    numbers = 1;
  } else {
    numbers = 0;
  }

  if (password.match(specialchars)) {
    special = 1;
  } else {
    special = 0;
  }

  return characters + capitalletters + lowerletters + numbers + special;
}

export function getStrength(password: string) {
  const total = checkStrength(password);
  if (total === -1) {
    return {
      msg: '',
    };
  }

  if (total <= 2) {
    return {
      msg: 'Weak',
      error: true,
    };
  } else if (total === 3) {
    return {
      msg: 'Medium',
      warning: true,
    };
  }

  return {
    msg: 'Strong',
    valid: true,
  };
}
